import Icon from 'molecules/Icon';

import type { FC } from 'react';
import type { LayoutProps } from 'types/global';

const AnnouncementBar: FC<AnnouncementBarProps> = ({ button, label }) => {
  if (!label) {
    return null;
  }

  return (
    <div className="hidden bg-primary-50 px-4 py-3 sm:block">
      {button?.link ? (
        <a href={button.link} className="group mx-auto flex w-full max-w-[1216px] items-center gap-3">
          <p className="font-roboto text-md font-semibold text-gray-900 group-hover:text-primary-1100">{label}</p>
          <span className="flex items-center gap-1.5 font-roboto text-md font-bold text-gray-900 group-hover:text-primary-1100">
            {button.label}
            <Icon icon="arrow-right-circle" />
          </span>
        </a>
      ) : (
        <div className="mx-auto flex w-full max-w-[1216px] items-center gap-3">
          <p className="font-roboto text-md font-semibold text-gray-900">{label}</p>
        </div>
      )}
    </div>
  );
};

/**
 * Renders a footer component using content from the Builder.io platform.
 *
 * This function retrieves the footer content from Builder.io and renders it using the `RenderBuilderContent` component.
 *
 * @returns {JSX.Element} The rendered footer component.
 */
export const AnnouncementBarWithBuilder = ({ content }: LayoutProps) => <AnnouncementBar {...content?.data} />;

export default AnnouncementBar;
